import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';

import { BestOddsGuaranteeBadgeComponent } from '@frontend/sports/bog-help/feature';
import { switchMap } from 'rxjs';

import { BestOddsFixtureLikeInput } from './models/models';
import { BestOddsGuaranteedService } from './services/best-odds-guaranteed.service';

@Component({
    selector: 'ms-race-view-best-odds-badge',
    template: `
        @if (showBadge()) {
            <ms-bog-help-badge />
        }
    `,
    imports: [BestOddsGuaranteeBadgeComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RaceViewBestOddsBadgeComponent {
    private readonly bestOddsService = inject(BestOddsGuaranteedService);

    fixture = input.required<BestOddsFixtureLikeInput>();
    private fixture$ = toObservable(this.fixture);

    showBadge = toSignal(this.fixture$.pipe(switchMap((fixture) => this.bestOddsService.isFixtureEligible(fixture))), { requireSync: false });
}
